<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ title }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" @click="cancel">Cancel</base-button>
          <base-button size="sm" type="neutral" @click="openCommentsModal" v-if="$route.params.id">
            <span class="btn-inner--icon"><i class="fas fa-sticky-note"></i></span>
              <span class="btn-inner--text">Notes</span>
          </base-button>
          <span v-if="integrations.length > 0">
            <base-button size="sm" type="neutral" v-b-toggle.deal-sidebar v-if="form.deal_id">
              <span class="btn-inner--icon"><img src="/img/fub/fub-icon.png" /></span>
                <span class="btn-inner--text"></span>
            </base-button>
            <base-button size="sm" type="neutral" v-b-modal.create-deal v-if="form.deal_id == null && form.id && fubIntegration">
              <span class="btn-inner--icon"><img src="/img/fub/fub-icon.png" /></span>
                <span class="btn-inner--text"></span>
            </base-button>
          </span>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <validation-observer v-slot="{ invalid }" ref="formValidator">
        <form class="needs-validation" ref="transactionForm"
              @submit.prevent="submit">
          <b-row class="py-4">
            <b-col md="4" class="pt-4">
              <h4>General Information</h4>
            </b-col>
            <b-col>
              <b-card no-body>
                <b-card-header>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm" class="float-right">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('740856415?h=b798ff8a3e', 'Listing Status')">Listing Status</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('740856516?h=4c87d15fde', 'Transaction Status')">Transaction Status</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('740856405?h=7d7853c38f', 'Listing Type')">Listing Type</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('740856501?h=663a5b733a', 'Transaction Type')">Transaction Type</b-link></b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body>
                  <base-input label="Status">
                    <el-select v-model="form.status" placeholder="Select a Status">
                      <el-option v-if="newListing" v-for="status in statuses.listings" :key="status.key" :value="status.value" :label="status.label"></el-option>
                      <el-option v-if="newTransaction" v-for="status in statuses.transactions" :key="status.key" :value="status.value" :label="status.label"></el-option>
                      <el-option-group label="Listing Statuses" v-if="editListingTransaction">
                        <el-option v-for="status in statuses.listings" :key="status.key" :value="status.value" :label="status.label"></el-option>
                      </el-option-group>
                      <el-option-group label="Transaction Statuses" v-if="editListingTransaction">
                        <el-option v-for="status in statuses.transactions" :key="status.key" :value="status.value" :label="status.label"></el-option>
                      </el-option-group>
                    </el-select>
                  </base-input>

                  <base-input label="Sale Type" :rules="{required: { transactionStatus: true } }"  name="Sale Type" v-if="transactionStatus">
                      <el-select v-model="form.sale_type" placeholder="Select a Type">
                        <el-option value="Listing" label="Listing"></el-option>
                        <el-option value="Buyer" label="Buyer"></el-option>
                      </el-select>
                  </base-input>

                  <base-input label="Transaction Type" rules="required" name="Transaction Type">
                    <el-select v-model="form.transaction_type" placeholder="Select a Type">
                      <el-option value="Resale" label="Resale"></el-option>
                      <el-option value="New Construction" label="New Construction"></el-option>
                      <el-option value="Referral In" label="Referral In"></el-option>
                      <el-option value="Referral Out" label="Referral Out"></el-option>
                      <el-option value="Lease" label="Lease"></el-option>
                      <el-option value="Lot" label="Lot"></el-option>
                      <el-option value="Commercial" label="Commercial"></el-option>
                    </el-select>
                  </base-input>

                  <base-input label="Do you want this transaction to count towards your annual unit goal?" label-for="units">
                    <base-switch class="mr-1" v-model="form.units"></base-switch>
                  </base-input>

                  <div v-if="listingStatus">
                    <base-input label-for="listing_date">
                      <label class="form-control-label">Listing Date: <span id="listing-date"><i class="fas fa-question-circle"></i></span></label>
                      <b-tooltip target="listing-date" triggers="hover" variant="danger">
                        Date that the listing agreement was signed.
                      </b-tooltip>
                      <b-form-datepicker v-model="form.listing_date" required placeholder="Choose a date" local="en"></b-form-datepicker>
                    </base-input>

                    <base-input label-for="target_mls_date">
                      <label class="form-control-label">Target MLS Date: <span id="target-mls-date"><i class="fas fa-question-circle"></i></span></label>
                      <b-tooltip target="target-mls-date" triggers="hover" variant="danger">
                        Date the listing is projected to go in the MLS
                      </b-tooltip>
                      <b-form-datepicker v-model="form.target_mls_date" required placeholder="Choose a date" local="en"></b-form-datepicker>
                    </base-input>

                    <base-input label-for="active_date" v-if="form.status != 'coming-soon'">
                        <label class="form-control-label">Active Date: <span id="active-date"><i class="fas fa-question-circle"></i></span></label>
                        <b-tooltip target="active-date" triggers="hover" variant="danger">
                          The date the listing went active on MLS
                        </b-tooltip>
                      <b-form-datepicker v-model="form.active_date" placeholder="Choose a date" local="en"></b-form-datepicker>
                    </base-input>

                    <base-input label="Contract Estimated Close Date:" label-for="close_date">
                      <b-form-datepicker v-model="form.close_date" required placeholder="Choose a date" local="en"></b-form-datepicker>
                    </base-input>

                    <base-input label-for="expiration_date">
                      <label class="form-control-label">Expiration Date: <span id="expiration-date"><i class="fas fa-question-circle"></i></span></label>
                      <b-tooltip target="active-date" triggers="hover" variant="danger">
                          This is the day this listing will come off of the MLS and the contract ends for this listing.
                        </b-tooltip>
                      <b-form-datepicker v-model="form.expiration_date" required placeholder="Choose a date" local="en"></b-form-datepicker>
                    </base-input>
                  </div>

                  <div v-if="transactionStatus">
                    <base-input label-for="contract_date">
                        <label class="form-control-label">Ratified Contract Date: <span id="contract-date"><i class="fas fa-question-circle"></i></span></label>
                        <b-tooltip target="contract-date" triggers="hover" variant="danger">
                          What date was the purchase agreement ratified by buyer and seller?
                        </b-tooltip>
                      <b-form-datepicker v-model="form.contract_date" required placeholder="Choose a date" local="en"></b-form-datepicker>
                    </base-input>

                    <base-input label="Contract Estimated Close Date:" label-for="close_date">
                      <b-form-datepicker v-model="form.close_date" required placeholder="Choose a date" local="en"></b-form-datepicker>
                    </base-input>
                  </div>

                  <base-input label="Is this transaction contingent on another sale?" label-for="contingent_sale">
                    <base-switch class="mr-1" v-model="form.contingent_sale"></base-switch>
                  </base-input>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="py-4">
            <b-col md="4">
              <h4>Client Information</h4>
              <b-button v-b-modal.fub-people-search v-if="fubIntegration"><img src="/img/integrations/fub-icon.png" style="height: 0.875rem; margin-right: 5px; vertical-align: unset;" /> Search FUB</b-button>
            </b-col>
            <b-col>
              <b-card no-body>
                <b-card-header>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm" class="float-right">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('740856489?h=e22ada389a', 'Client Information')">Client Information</b-link></b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body>
                  <b-row>
                    <b-col md="4">
                      <base-input label="Client Name"
                                  name="Client Name"
                                  rules="required"
                                  v-model="form.client.name">
                      </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-input label="Client Phone"
                                  name="Client Phone"
                                  v-model="form.client.phone">
                      </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-input label="Client Email"
                                  name="Client Email"
                                  v-model="form.client.email">
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <base-input label="Address"
                                  name="Address"
                                  rules="required"
                                  v-model="form.property.address">
                      </base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input label="City"
                                  name="City"
                                  rules="required"
                                  v-model="form.property.city">
                      </base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input label="State/Province"
                                  name="State/Province"
                                  rules="required"
                                  v-model="form.property.state">
                      </base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input label="Postal Code"
                                  name="Postal Code"
                                  rules="required"
                                  v-model="form.property.zipcode">
                      </base-input>
                    </b-col>
                  </b-row>

                  <base-input label="Primary Source">
                    <el-select v-model="form.primary_source"
                               filterable
                               placeholder="i.e. Database, Zillow">
                      <el-option v-for="(source, key) in primarySources"
                                 :key="source"
                                 :label="source"
                                 :value="source">
                      </el-option>
                    </el-select>
                  </base-input>

                  <base-input label="Database Sub Source" v-if="form.primary_source == 'Database'">
                    <el-select v-model="form.source"
                               filterable
                               allow-create
                               placeholder="i.e. Past Client, SOI, Vendor Referral">
                      <el-option v-for="(source, key) in sources"
                                 :key="source"
                                 :label="source"
                                 :value="source">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="py-4">
            <b-col md="4">
              <h4>Income</h4>
              <b-card no-body>
                <b-list-group flush>
                  <b-list-group-item><b-link href="#" @click="startHowTo('740856476?h=4f0e7ab6ad', 'Commission')">Commission</b-link></b-list-group-item>
                  <b-list-group-item><b-link href="#" @click="startHowTo('740856466?h=dc38f4e7b8', 'Transaction Fee')">Transaction Fee</b-link></b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
            <b-col>
              <b-card no-body>
                <b-card-body>
                  <base-input label="Sale Price:"
                              type="number"
                              step="0.01"
                              min="0"
                              input-group-classes="input-group-merge"
                              :rules="{ required: { transactionStatus: true }, min_value:1 }"
                              name="Sale Price"
                              prependIcon="fas fa-dollar-sign"
                              v-model="form.sale_price"
                              v-if="transactionStatus">
                  </base-input>

                  <base-input label="Listing Price"
                              type="number"
                              step="0.01"
                              min="0"
                              input-group-classes="input-group-merge"
                              :rules="{ required: { listingStatus: true }, min_value:1 }"
                              name="Listing Price"
                              prependIcon="fas fa-dollar-sign"
                              v-model="form.listing_price"
                              v-if="listingStatus">
                  </base-input>

                  <div>
                    <label class="form-control-label" v-if="listingStatus">Commission Charged to Seller:</label>
                    <label class="form-control-label" v-else>Commission:</label>
                  </div>
                  <b-row>
                    <b-col md="3">
                      <base-input label-for="commission_type">
                        <b-form-radio-group v-model="form.commission_type" name="commission_type" button-variant="outline-danger" buttons :required="transactionStatus">
                          <b-form-radio value="0" name="Percentage"><i class="fas fa-percent ml-0"></i></b-form-radio>
                          <b-form-radio value="1" name="Flat Rate"><i class="fas fa-dollar-sign ml-0"></i></b-form-radio>
                        </b-form-radio-group>
                      </base-input>
                    </b-col>
                    <b-col>
                      <base-input label=""
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  input-group-classes="input-group-merge"
                                  name="Commission Amount"
                                  v-model="form.amount"
                                  rules="min_value:0|required">
                        <template #prepend v-if="form.commission_type == 1"><i class="fas fa-dollar-sign"></i></template>
                        <template #append v-if="form.commission_type == 0"><i class="fas fa-percent"></i></template>
                      </base-input>
                    </b-col>
                  </b-row>
                  <div v-if="listingStatus">
                    <label class="form-control-label">Commission offered to Cooperating Broker:</label>
                    <b-row>
                      <b-col md="3">
                        <base-input label="" label-for="broker_commission_type">
                          <b-form-radio-group v-model="form.broker_commission_type" button-variant="outline-danger" buttons name="broker_commission_type">
                            <b-form-radio value="0" checked><i class="fas fa-percent ml-0"></i></b-form-radio>
                            <b-form-radio value="1"><i class="fas fa-dollar-sign ml-0"></i></b-form-radio>
                          </b-form-radio-group>
                        </base-input>
                      </b-col>
                      <b-col>
                        <base-input label=""
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    input-group-classes="input-group-merge"
                                    name="Broker Commission Amount"
                                    v-model="form.broker_commission_amount"
                                    :helperText="'Broker Commission: ' + brokerCommission | currency">
                          <template #prepend v-if="form.broker_commission_type == 1"><i class="fas fa-dollar-sign"></i></template>
                          <template #append v-if="form.broker_commission_type == 0"><i class="fas fa-percent"></i></template>
                        </base-input>
                      </b-col>
                    </b-row>
                  </div>
                  <base-input label="Transaction Fee:" 
                              label-for="transaction_fee"
                              type="number"
                              step="0.01"
                              min="0"
                              input-group-classes="input-group-merge"
                              prependIcon="fas fa-dollar-sign"
                              v-model="form.transaction_fee">
                  </base-input>
                      
                  <p class="form-control-label"><strong>Total Commission:</strong> {{ commission | currency }}</p>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="py-4">
            <b-col md="4">
              <h4>Cost of Sale</h4>
            </b-col>
            <b-col>
              <b-card no-body>
                <b-card-header>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm" class="float-right">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('740856454?h=74dbef6207', 'Agent Commission')">Agent Commission</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('740856435?h=83e57b19c9', 'Broker & Franchise Fee')">Broker & Franchise Fee</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('740856447?h=860ef7091a', 'Additional Cost of Sale')">Additional Cost of Sale</b-link></b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body>
                    <h3>Who Is Getting Paid On This Transaction?</h3>

                    <base-input label="Who's sale is this?" label-for="agent_id">
                      <el-select v-model="form.agent_id">
                        <el-option v-for="member in members"
                                   :key="member.id"
                                   :label="member.name"
                                   :value="member.id">
                        </el-option>
                      </el-select>
                    </base-input>

                    <base-input label="Are you paying a referral fee on this sale?" label-for="referral_fee">
                      <base-switch class="mr-1" v-model="form.referral_fee"></base-switch>
                    </base-input>

                    <b-row v-if="form.referral_fee == 1">
                      <b-col>
                        <base-input label="Referral Type:" label-for="referral_type">
                          <b-form-radio-group v-model="form.referral_type" button-variant="outline-danger" buttons name="referral_type">
                            <b-form-radio value="0" checked><i class="fas fa-percent ml-0"></i></b-form-radio>
                            <b-form-radio value="1"><i class="fas fa-dollar-sign ml-0"></i></b-form-radio>
                          </b-form-radio-group>
                        </base-input>
                      </b-col>
                      <b-col>
                        <base-input label="Referral Fee Amount:"
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    rules="min_value:0|required"
                                    input-group-classes="input-group-merge"
                                    name="Referral Feel Amount"
                                    v-model="form.referral_amount">
                          <template #prepend v-if="form.referral_type == 1"><i class="fas fa-dollar-sign"></i></template>
                          <template #append v-if="form.referral_type == 0"><i class="fas fa-percent"></i></template>
                          <template #helperText><small class="text-muted">Referral Fee: {{ referralFee | currency }}</small></template>
                        </base-input>
                      </b-col>
                    </b-row>

                    <span>Team Member Compensation:</span>
                    <p class="small text-danger"><em>NOTE: ONLY INCLUDE TEAM MEMBERS THAT WILL RECEIVE COMPENSATION ON THE SALE. IF YOU ARE THE OWNER OF THE TEAM AND IT IS YOUR SALE, DO NOT ADD YOURSELF AS RECEIVING A SPLIT.</em></p>
                    <div v-for="(member, index) in form.members" :key="index">
                      <b-row>
                        <b-col md="4">
                          <label class="form-control-label">Member:</label>
                          <b-input-group label-for="member">
                            <template #prepend>
                              <b-button size="sm" variant="danger" @click="removeMember(index)"><i class="fas fa-trash px-2"></i></b-button>
                            </template>
                            <b-form-select v-model="member.id" @change="addMemberName(member)" required>
                              <b-form-select-option :value="member.id" v-for="member in members" :key="member.id">{{ member.name }}</b-form-select-option>
                            </b-form-select>
                          </b-input-group>
                        </b-col>
                        <b-col md="4" class="text-center">
                          <base-input label="Commission Type:" label-for="type">
                            <b-form-radio-group v-model="member.commission_type" :name="'member-' + member.id" button-variant="outline-danger" buttons>
                              <b-form-radio value="0" checked><i class="fas fa-percent ml-0"></i></b-form-radio>
                              <b-form-radio value="1"><i class="fas fa-dollar-sign ml-0"></i></b-form-radio>
                            </b-form-radio-group>
                          </base-input>
                        </b-col>
                        <b-col md="4">
                          <base-input type="number"
                                      step="0.01"
                                      min="0"
                                      input-group-classes="input-group-merge"
                                      label="Commission Amount:" 
                                      label-for="amount"
                                      name="Commission Amount"
                                      v-model="member.amount"
                                      rules="min_value:0|required">
                            <template #prepend v-if="member.commission_type == 1"><i class="fas fa-dollar-sign"></i></template>
                            <template #append v-if="member.commission_type == 0"><i class="fas fa-percent"></i></template>
                            <template #helperText>
                              <small class="text-muted">
                                Commission: {{ memberCommission(member) | currency }}
                              </small>
                            </template>
                          </base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4">
                          <base-input label="Is this member paying a Cap?" label-for="cap">
                            <base-switch class="mr-1" v-model="member.cap"></base-switch>
                          </base-input>
                        </b-col>
                        <b-col md="4" class="text-center" v-if="member.cap == 1">
                          <base-input label="Cap Type:" label-for="type">
                            <b-form-radio-group v-model="member.cap_type" :name="'member-cap-' + member.id" button-variant="outline-danger" buttons>
                              <b-form-radio value="0" checked><i class="fas fa-percent ml-0"></i></b-form-radio>
                              <b-form-radio value="1"><i class="fas fa-dollar-sign ml-0"></i></b-form-radio>
                            </b-form-radio-group>
                          </base-input>
                        </b-col>
                        <b-col md="4" v-if="member.cap == 1">
                          <base-input type="number"
                                      step="0.01"
                                      min="0"
                                      input-group-classes="input-group-merge"
                                      label="Cap Amount:" 
                                      label-for="amount"
                                      name="Cap Amount"
                                      v-model="member.cap_amount"
                                      rules="min_value:0">
                            <template #prepend v-if="member.cap_type == 1"><i class="fas fa-dollar-sign"></i></template>
                            <template #append v-if="member.cap_type == 0"><i class="fas fa-percent"></i></template>
                            <template #helperText>
                              <small class="text-muted">
                                Cap: {{ memberCap(member) | currency }}
                              </small>
                            </template>
                          </base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4">
                          <base-input label="Is your member paying Royalties?" label-for="cos">
                            <base-switch class="mr-1" v-model="member.royalty"></base-switch>
                          </base-input>
                        </b-col>
                        <b-col md="4" class="text-center" v-if="member.royalty">
                          <base-input label="Royalties Type:" label-for="type" class="mt-4">
                            <b-form-radio-group v-model="member.royalty_type" :name="'member-royalty-' + member.id" button-variant="outline-danger" buttons>
                              <b-form-radio value="0" checked><i class="fas fa-percent ml-0"></i></b-form-radio>
                              <b-form-radio value="1"><i class="fas fa-dollar-sign ml-0"></i></b-form-radio>
                            </b-form-radio-group>
                          </base-input>
                        </b-col>
                        <b-col md="4" v-if="member.royalty">
                          <base-input type="number"
                                      step="0.01"
                                      min="0"
                                      input-group-classes="input-group-merge"
                                      label="Royalties Amount:" 
                                      label-for="amount"
                                      name="Royalties Amount"
                                      v-model="member.royalty_amount"
                                      rules="min_value:0">
                            <template #prepend v-if="member.royalty_type == 1"><i class="fas fa-dollar-sign"></i></template>
                            <template #append v-if="member.royalty_type == 0"><i class="fas fa-percent"></i></template>
                            <template #helperText>
                              <small class="text-muted">
                                Royalties: {{ memberRoyalties(member) | currency }}
                              </small>
                            </template>
                          </base-input>
                        </b-col>
                      </b-row>
                      <b-row class="mb-4 mt--3">
                        <b-col>
                          <small>
                            <strong>{{ member.name }}'s total commission: {{ memberCommission(member) - memberCap(member) - memberRoyalties(member) | currency }}</strong>
                          </small>
                        </b-col>
                      </b-row>
                    </div>

                    <base-input>
                      <b-button size="sm" variant="primary" @click="addMember">Add member</b-button>
                    </base-input>

                    <base-input label="Are you paying your broker a split on this sale?" label-for="broker_paid">
                      <base-switch class="mr-1" v-model="form.broker_paid"></base-switch>
                    </base-input>

                    <b-row v-if="form.broker_paid == 1">
                      <b-col md="6">
                        <base-input label="Broker Type:" label-for="broker_type">
                          <b-form-radio-group v-model="form.broker_type" name="broker_type" button-variant="outline-danger" buttons>
                            <b-form-radio value="0" checked><i class="fas fa-percent ml-0"></i></b-form-radio>
                            <b-form-radio value="1"><i class="fas fa-dollar-sign ml-0"></i></b-form-radio>
                          </b-form-radio-group>
                        </base-input>
                      </b-col>
                      <b-col md="6">
                        <base-input type="number"
                                    step="0.01"
                                    min="0"
                                    input-group-classes="input-group-merge"
                                    label="Broker Amount:"
                                    label-for="broker_amount"
                                    name="Broker Split Amount"
                                    v-model="form.broker_amount"
                                    rules="min_value:0|required">
                          <template #prepend v-if="form.broker_type == 1"><i class="fas fa-dollar-sign"></i></template>
                          <template #append v-if="form.broker_type == 0"><i class="fas fa-percent"></i></template>
                          <template #helperText><small class="text-muted">Broker Split: {{ brokerTotal | currency }}</small></template>
                        </base-input>
                      </b-col>
                    </b-row>

                    <base-input label="Are you paying a Franchise Fee on this transaction?" label-for="franchise_fee_paid">
                      <base-switch class="mr-1" v-model="form.franchise_fee_paid"></base-switch>
                    </base-input>

                    <b-row v-if="form.franchise_fee_paid == 1">
                      <b-col md="6">
                        <base-input label="Franchise Fee Type:" label-for="franchise_fee_type">
                          <b-form-radio-group v-model="form.franchise_fee_type" name="franchise_fee_type" button-variant="outline-danger" buttons>
                            <b-form-radio value="0" checked><i class="fas fa-percent ml-0"></i></b-form-radio>
                            <b-form-radio value="1"><i class="fas fa-dollar-sign ml-0"></i></b-form-radio>
                          </b-form-radio-group>
                        </base-input>
                      </b-col>
                      <b-col md="6">
                        <base-input type="number"
                                    step="0.01"
                                    min="0"
                                    input-group-classes="input-group-merge"
                                    label="Franchise Fee Amount:" 
                                    label-for="franchise_fee_amount"
                                    name="Franchise Fee Amount"
                                    v-model="form.franchise_fee_amount"
                                    rules="min_value:0|required">
                          <template #prepend v-if="form.franchise_fee_type == 1"><i class="fas fa-dollar-sign"></i></template>
                          <template #append v-if="form.franchise_fee_type == 0"><i class="fas fa-percent"></i></template>
                          <template #helperText><small class="text-muted">Franchise Fee: {{ franchiseFeeTotal | currency }}</small></template>
                        </base-input>
                      </b-col>
                    </b-row>

                    <base-input label-for="other_cos" 
                                class="py-1"
                                input-group-classes="input-group-merge"
                                type="number"
                                step="0.01"
                                min="0"
                                v-model="form.other_cos">
                      <template #label>
                        <label class="form-control-label">Additional Cost of Sale: <span id="other-cos"><i class="fas fa-question-circle"></i></span></label>
                        <b-tooltip target="other-cos" triggers="hover" variant="danger">
                          Are there any other costs you will incur when this transaction closes? I.E. Paying for a Home Warranty at closing, paying for inspection repairs at closing, etc.?
                        </b-tooltip>
                      </template>
                      <template #prepend><i class="fas fa-dollar-sign"></i></template>
                    </base-input>

                    <p class="form-control-label"><strong>Total Commission:</strong> {{ commission | currency }}</p>
                    <p class="form-control-label"><strong>Total Cost of Sale:</strong> {{ cosTotal | currency }}</p>
                    <p class="form-control-label"><strong>Gross Profit:</strong> {{ grossProfit | currency}}</p>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="py-4">
            <b-col md="4">
              <h4>Vendor Information</h4>
            </b-col>
            <b-col>
              <b-card no-body>
                <b-card-header>
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm" class="float-right">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('740856423?h=a032f952ec', 'Vendor Information')">Vendor Information</b-link></b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body>
                  <p><strong>What companies are associated with this transaction?</strong></p>
                  <b-row v-for="(company, index) in form.companies" :key="index">
                    <b-col md="6">
                      <base-input label="Company Name:" label-for="company">
                        <b-input-group>
                          <template #prepend>
                            <b-button size="sm" variant="danger" @click="removeCompany(index)">Remove</b-button>
                          </template>
                          <b-form-input v-model="company.name" type="text"></b-form-input>
                        </b-input-group>
                      </base-input>
                    </b-col>
                    <b-col md="6">
                      <base-input label="Company Type:" label-for="amount" rules="required" name="Company Type">
                        <el-select v-model="company.type" required>
                          <el-option label="Select a Type" :value="null"></el-option>
                          <el-option :value="0" label="Mortgage Company"></el-option>
                          <el-option :value="1" label="Title Company"></el-option>
                          <el-option :value="2" label="Law Firm"></el-option>
                          <el-option :value="3" label="Home Inspection"></el-option>
                          <el-option :value="4" label="Home Insurance"></el-option>
                          <el-option :value="6" label="Photography"></el-option>
                          <el-option :value="7" label="Contractor"></el-option>
                          <el-option :value="8" label="Stager"></el-option>
                          <el-option :value="9" label="Other"></el-option>
                        </el-select>
                      </base-input>
                    </b-col>
                  </b-row>

                  <base-input>
                    <b-button variant="primary" @click="addCompany">Add Company</b-button>
                  </base-input>

                  <p><strong>Would you like to add a Loan Officer, Escrow Officer, or an Attorney?</strong></p>
                  <b-row v-if="officers">
                    <b-col md="6">
                      <base-input label="Loan Officer:" label-for="loan_officer">
                        <b-form-input v-model="form.loan_officer" type="text"></b-form-input>
                      </base-input>
                    </b-col>
                    <b-col md="6">
                      <base-input label="Escrow Officer/Attorney Name:" label-for="escrow_officer">
                        <b-form-input v-model="form.escrow_officer" type="text"></b-form-input>
                      </base-input>
                    </b-col>
                  </b-row>

                  <base-input v-if="!officers">
                    <b-button variant="primary" @click="officers = true">Add Officers</b-button>
                  </base-input>
                </b-card-body>
              </b-card>

              <ul v-if="errorList" class="text-danger">
                <li v-for="(error, index) in errorList" :key="index">{{ error }}</li>
              </ul>

              <base-button block type="success" native-type="submit">Submit</base-button>
            </b-col>
          </b-row>
        </form>
      </validation-observer>
    </b-container>
    <how-to-modal :source="howToVideo" :video_title="howToTitle"></how-to-modal>
    <comments-modal :type="'transactions'"
                 :typeId="$route.params.id"
                 :userRoute="userRoute">
    </comments-modal>
    <fub-people-search :userRoute="userRoute" @addClient="addClient" v-if="fubIntegration"></fub-people-search>
    <address-select :person="person" @fillAddress="fillAddress" v-if="fubIntegration"></address-select>
    <create-deal :transaction="form" :userRoute="userRoute" :commission="commission" :teamCommission="agentFees" @getTransaction="getTransaction" v-if="fubIntegration"></create-deal>
    <deal :dealId="form.deal_id" :userRoute="userRoute" v-if="fubIntegration"></deal>
    <update-deal :transaction="form" :commission="commission" :deal_id="form.deal_id" :userRoute="userRoute" :backRoute="backRoute" v-if="fubIntegration"></update-deal>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import {Select, OptionGroup, Option} from 'element-ui';
import initialState from './FormData/transactionFormData';
import errorsMixin from '@/mixins/errors-mixin';
import sourcesMixin from '@/mixins/sources-mixin';
import HowToModal from '@/views/Components/Modals/HowToModal';
import CommentsModal from '@/views/Components/Modals/CommentsModal';
import FubPeopleSearch from '@/views/Components/Modals/FubPeopleSearch';
import AddressSelect from '@/views/Components/FUB/AddressSelect';
import CreateDeal from '@/views/Components/FUB/CreateDeal';
import Deal from '@/views/Components/FUB/Deal';
import UpdateDeal from '@/views/Components/FUB/UpdateDeal';

export default {
  mixins: [errorsMixin, sourcesMixin],
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [OptionGroup.name]: OptionGroup,
    [Option.name]: Option,
    HowToModal,
    CommentsModal,
    FubPeopleSearch,
    AddressSelect,
    CreateDeal,
    Deal,
    UpdateDeal
  },
  props: {
    transaction: null
  },
  data() {
    return initialState();
  },
  computed: {
    backUrl() {
      if(this.$route.params.user) {
        return "/observatory/" + this.$route.params.user + "/";
      }
      return "/";
    },
    backRoute() {
      const routeName = this.$route.name;

      switch(routeName) {
        case 'New Listing':
        case 'Edit Listing':
          return this.backUrl + "listings";
        default:
          return this.backUrl + "transactions";
      }
    },
    title() {
      const routeName = this.$route.name;

      switch(routeName) {
        case 'New Listing':
          return 'New Listing';
        case 'Edit Listing':
          return 'Edit Listing';
        case 'New Transaction':
          return 'New Transaction';
        case 'Edit Transaction':
          return 'Edit Transaction';
        default:
          return '';
      }
    },
    userRoute() {
      if(this.$route.params.user) {
        return process.env.VUE_APP_API_BASE_URL + "/users/" + this.$route.params.user;
      }
      return this.$store.getters['profile/userRoute'];
    },
    listingStatus() {
      return this.listings.includes(this.form.status);
    },
    transactionStatus() {
      return this.transactions.includes(this.form.status);
    },
    commission() {
      if(this.form.commission_type == 1) {
        if(this.listingStatus) {
          return Number(this.form.amount) - this.brokerCommission;
        } else {
          return Number(this.form.amount);
        }
      } else {
        if(this.listingStatus) {
          return (Number(this.form.listing_price) * (Number(this.form.amount) / 100) - this.brokerCommission);
        }

        return Number(this.form.sale_price) * (Number(this.form.amount) / 100);
      }
    },
    grossProfit() {
      return this.commission - this.cosTotal + Number(this.form.transaction_fee);
    },
    brokerCommission() {
      if(this.form.broker_commission_type == 1) {
        return Number(this.form.broker_commission_amount);
      } else {
        return Number(this.form.listing_price) * (Number(this.form.broker_commission_amount) / 100);
      }
    },
    brokerTotal() {
      if(this.form.broker_type == true) {
        return Number(this.form.broker_amount);
      } else {
        return (this.commission - this.referralFee - this.agentFees) * (this.form.broker_amount / 100);
      }
    },
    franchiseFeeTotal() {
      if(this.form.franchise_fee_type == true) {
        return Number(this.form.franchise_fee_amount);
      } else {
        return (this.commission - this.referralFee - this.agentFees) * (this.form.franchise_fee_amount / 100);
      }
    },
    referralFee() {
      if(this.form.referral_type == true) {
        return Number(this.form.referral_amount);
      } else {
        return (this.commission) * (this.form.referral_amount / 100);
      }
    },
    cosTotal() {
      const referralFee = this.referralFee;
      const brokerTotal = this.brokerTotal;
      const franchiseFeeTotal = this.franchiseFeeTotal;
      const agentFees = this.agentFees;

      return referralFee + brokerTotal + franchiseFeeTotal + Number(this.form.other_cos) + agentFees;
    },
    agentFees() {
      let commission = 0;
      const commissionTotal = this.commission - this.referralFee;
      const referralFee = this.referralFee;

      Object.values(this.form.members).forEach(member => {
        if(member.commission_type == 1) {
          commission = commission + Number(member.amount);
        } else {
          commission = commission + (commissionTotal * (Number(member.amount) / 100));
        }
      });

      return commission;
    },
    newListing() {
      return this.$route.name == 'New Listing' || this.$route.name == 'Observatory Create Listing';
    },
    newTransaction() {
      return this.$route.name == 'New Transaction' || this.$route.name == 'Observatory Create Transaction';
    },
    editListingTransaction() {
      return this.$route.name == 'Edit Listing' || this.$route.name == 'Edit Transaction' || this.$route.name == 'Observatory Edit Listing' || this.$route.name == 'Observatory Edit Transaction';
    },
    integrations() {
      if(this.$route.params.user) {
        return this.$store.getters['observed/observed'].integrations;
      }
      return this.$store.getters['profile/user'].integrations;
    },
    fubIntegration() {
      return this.integrations.includes('follow-up-boss');
    }
  },
  methods: {
    async submit() {
      this.errorList = null;
      const isValid = await this.$refs.formValidator.validate();

      if(!isValid) {
        this.errorList = Object.values(this.$refs.formValidator.errors).flat();
      } else {
        if(this.form.id) {
          this.update();
        } else {
          this.add();
        }
      }
    },
    async add() {
      axios.post(this.userRoute + "/transactions", this.form)
      .then(response => {
        if (response.data.transaction) {
          this.form = response.data.transaction;
        }

        swal.fire({
          title: `Success`,
          text: response.data.message ? response.data.message : response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          if (this.fubIntegration) {
            this.createDeal();
          } else {
            Object.assign(this.$data, initialState());
            this.$refs.formValidator.reset();
            this.$router.push({
              path: this.backRoute
            });
          }
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async update() {
      axios.patch(this.userRoute + "/transactions/" + this.form.id, this.form)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          if (this.form.deal_id) {
            this.updateDeal();
          } else {
            if (this.fubIntegration) {
              this.createDeal();
            } else {
              Object.assign(this.$data, initialState());
              this.$refs.formValidator.reset();
              this.$router.push({
                path: this.backRoute
              });
            }
          }
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    cancel() {
      Object.assign(this.$data, initialState());
      this.$router.push({
        path: this.backRoute
      });
    },
    updateForm() {
      this.form = (this.transaction) ? this.transaction : formData;
    },
    getClients() {
      axios.get(this.userRoute + "/clients")
      .then(response => {
        this.clients = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    getMembers() {
      axios.get(this.userRoute + "/members/team?active=true")
      .then(response => {
        this.members = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    addMember() {
      this.form.members.push({
        id: "",
        name: "",
        amount: 0,
        commission_type: 0,
        cap: false,
        cap_type: 0,
        cap_amount: 0,
        royalty: false,
        royalty_type: 0,
        royalty_amount: 0 
      });
    },
    removeMember(index) {
      this.form.members.splice(index, 1);
    },
    addCompany() {
      this.form.companies.push({
        id: "",
        name: "",
        type: ""
      });
    },
    removeCompany(index) {
      this.form.companies.splice(index, 1);
    },
    async getTransaction() {
      axios.get(this.userRoute + "/transactions/" + this.$route.params.id)
      .then(response => {
        this.form = response.data;
        if (this.form.loan_officer || this.form.escrow_officer) {
          this.officer = true;
        }
      })
      .catch(error => {
        this.error(error);
      });
    },
    startHowTo(video, title) {
      this.howToVideo = video;
      this.howToTitle = title;
      this.$bvModal.show('how-to-modal');
    },
    openCommentsModal() {
      this.$bvModal.show('comments-modal');
    },
    addClient(client) {
     this.getPerson(client.id);
    },
    memberCommission(member) {
      if (member.commission_type == 0) {
        return (this.commission - this.referralFee) * (member.amount / 100);
      } else {
        return member.amount;
      }
    },
    memberCap(member) {
      if (member.cap) {
        if (member.cap_type == 0) {
          return this.memberCommission(member) * (member.cap_amount / 100);
        } else {
          return member.cap_amount;
        }
      } else {
        return 0;
      }
    },
    memberRoyalties(member) {
      if (member.royalty) {
        if (member.royalty_type == 0) {
          return this.memberCommission(member) * (member.royalty_amount / 100);
        } else {
          return member.royalty_amount;
        }
      } else {
        return 0;
      }
    },
    getPerson(person) {
      axios.get(this.userRoute + "/integrations/fub/people/person?personId=" + person)
      .then(response => {
        this.person = response.data;
        this.fillPerson(response.data);
      })
      .catch(error => {
        // error
      });
    },
    getDeal() {
      axios.get(this.userRoute + "/integrations/fub/deals/" + this.$route.query.deal)
      .then(response => {
        this.deal = response.data;
        this.fillDeal(response.data);
      })
      .catch(error => {
        // error
      });
    },
    fillPerson(attributes) {
      this.form.listing_price = attributes.price;
      this.form.sale_price = attributes.price;
      this.form.client.name = attributes.name;
      this.form.client.phone = attributes.phones.length > 0 ? attributes.phones[0].value : null;
      this.form.client.email = attributes.emails.length > 0 ? attributes.emails[0].value : null;
      this.$bvModal.show('address-modal');
    },
    fillAddress(address) {
      this.form.property.address = address.street;
      this.form.property.city = address.city;
      this.form.property.state = address.state;
      this.form.property.zipcode = address.code;
      this.$bvModal.hide('address-modal');
    },
    fillDeal(deal) {
      if (deal.people.length > 0) {
        this.getPerson(deal.people[0].id);
        this.form.listing_price = deal.price;
        this.form.sale_price = deal.price;
        this.form.listing_date = deal.projectedCloseDate;
        this.form.target_mls_date = deal.projectedCloseDate;
        this.form.active_date = deal.projectedCloseDate;
        this.form.close_date = deal.projectedCloseDate;
        this.form.commission_type = 1;
        this.form.amount = deal.commissionValue;
      }
    },
    updateDeal() {
      this.$bvModal.show('deal-update');
    },
    createDeal() {
      swal.fire({
        title: `Success`,
        text: 'Would you like to create or connect a FUB Deal?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        buttonsStyling: false,
        icon: 'info'
      }).then(result => {
        if (result.isConfirmed) {
          this.$bvModal.show('create-deal')
        } else {
          Object.assign(this.$data, initialState());
          this.$refs.formValidator.reset();
          this.$router.push({
            path: this.backRoute
          });
        }
      });
    },
    addMemberName(member) {
      let agent = this.members.filter(a => {
        return a.id === member.id;
      })[0];

      member.name = agent.name;
    }
  },
  created() {
    this.getClients();
    this.getMembers();

    if(this.$route.params.id) {
      this.getTransaction();
    }

    if(this.$route.query.person) {
      this.getPerson(this.$route.query.person);
    }

    if(this.$route.query.deal) {
      this.getDeal();
    }
  },
  mounted() {
    document.title = this.title + " | ClarityNOW";
  },
  watch: {
    'form.referral_fee'(value) {
      if(value == false) {
        this.form.referral_amount = 0;
      }
    },
    'form.broker_paid'(value) {
      if(value == false) {
        this.form.broker_amount = 0;
      }
    },
    'form.franchise_fee_paid'(value) {
      if(value == false) {
        this.form.franchise_fee_amount = 0;
      }
    },
    'form.status'(to, from) {
      if (from == 'pending' && to == 'closed') {
        const dateArray = this.form.close_date.split("-");
        const closeDate = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0];
        swal.fire({
          title: `Close Date`,
          text: `Please review the Close Date of ` + closeDate,
          showConfirmButton: true,
          icon: 'info'
        });
      }
    }
  },
}
</script>